import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminService } from '../../services/AdminService/admin';
import { PlatformWalletResponse } from '../../models/wallet.dto';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';
import { EmptyState } from '../../shared/components/empty-state/empty-state';

@Component({
  selector: 'app-platform-wallet',
  imports: [CommonModule, ErrorBanner, EmptyState],
  templateUrl: './platform-wallet.html',
  styleUrl: './platform-wallet.scss',
})
export class PlatformWallet implements OnInit {
  networks = signal<PlatformWalletResponse[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  constructor(private admin: AdminService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.admin.platformWallet().subscribe({
      next: (res) => {
        this.isLoading.set(false);
        this.networks.set(res.data);
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to load platform wallet.'));
      },
    });
  }
}
